import { P1_ERROR_SUFFIX, P1_WARNING_SUFFIX } from "../const/p1";

export const filterPrescriptionVerificationResults = 
(verificationResults: {
        code: string;
        result: string;
        description: string;
    }[]
) => {
    const errors = verificationResults.filter(r => r.result.endsWith(P1_ERROR_SUFFIX));
    const warnings = verificationResults.filter(r => r.result.endsWith(P1_WARNING_SUFFIX));

    return {
        errors,
        warnings
    };
}